module.exports = __webpack_public_path__ + "img/background-study-scoping@2x.ccfda85b.jpg";